import { isArray } from 'lodash';

import { getItem, setItem } from '../../utils/local-storage';

const STORAGE_KEY = 'ANNOUNCEMENTS_LOG';

function getSavedAnnouncementsLog() {
  const log = getItem(STORAGE_KEY);
  const announcements = log ? JSON.parse(log) : [];
  const isLogArray = isArray(announcements);
  return isLogArray ? announcements : [];
}

export function isAnnouncementViewed(announcements) {
  const ids = announcements.map(announcement => announcement.id);
  const filteredIds = ids.filter(
    id =>
      !getSavedAnnouncementsLog()
        .map(savedAnnouncement => savedAnnouncement.id)
        .includes(id),
  );
  return filteredIds.length === 0;
}

export function markAnnouncementAsViewed(announcements) {
  const announcementsIds = announcements.map(announcement => ({
    id: announcement.id,
    read: true,
  }));
  const newAnnouncements = announcementsIds.filter(
    announcement =>
      !getSavedAnnouncementsLog()
        .map(savedAnnouncement => savedAnnouncement.id)
        .includes(announcement.id),
  );
  setItem(
    STORAGE_KEY,
    JSON.stringify([...getSavedAnnouncementsLog(), ...newAnnouncements]),
  );
}
